const e = {
  name: "Document",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v34c0,1.7,1.3,3,3,3h22c1.7,0,3-1.3,3-3V11.6L16.4,0H3z M2,3c0-0.5,0.5-1,1-1h11v8.8
			c0,1.8,1.4,3.2,3.2,3.2H26v23c0,0.5-0.5,1-1,1H3c-0.5,0-1-0.5-1-1V3z M25.6,12h-8.4c-0.6,0-1.2-0.5-1.2-1.2V2.4L25.6,12z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Document
};
